import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import AutoComplete from 'material-ui/AutoComplete'

const mapStateToProps = state => ({
  userInfo: state.userInfo,
  typeAheadSource: state.typeAheadSource
})

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

class TypeAhead extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchText: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.clearText) {
      this.setState({
        searchText: ''
      })
    }
  }

  handleUpdate = searchText => {
    this.setState({
      searchText
    })
    if (this.props.typeAheadSource && this.props.typeAheadSource[searchText]) {
      this.props.onChange(this.props.typeAheadSource[searchText])
      this.setState({
        searchText: ''
      })
    } else {
      const { dispatch, getDataFunction } = this.props
      getDataFunction(searchText)
    }
  }

  render() {
    const dataSource = this.props.typeAheadSource
      ? Object.keys(this.props.typeAheadSource)
      : []
    return (
      <AutoComplete
        hintText={this.props.hintText}
        filter={AutoComplete.caseInsensitiveFilter}
        dataSource={dataSource}
        searchText={this.state.searchText}
        onUpdateInput={this.handleUpdate}
        maxSearchResults={10}
      />
    )
  }
}

TypeAhead.propTypes = {
  hintText: PropTypes.string,
  onChange: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  getDataFunction: PropTypes.func,
  typeAheadSource: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(TypeAhead)



/** WEBPACK FOOTER **
 ** ./src/components/TypeAhead/TypeAhead.js
 **/